import { sleep } from "@shared/utils/tools.ts";

export default async (sleepDuration?: number) => {
  await sleep(sleepDuration || 350);
  return {};
};
